import { thunkHandler } from "../../libs/utils";

export const VALIDATE_SURA_TOKEN_SUCCESS = 'VALIDATE_SURA_TOKEN_SUCCESS';
export const VALIDATE_SURA_TOKEN = 'VALIDATE_SURA_TOKEN';

export function validateSuraToken (token) {
  return dispatch => {
    dispatch({ type: VALIDATE_SURA_TOKEN, payload: token })
    setTimeout(() => {
      thunkHandler(dispatch, token, VALIDATE_SURA_TOKEN_SUCCESS, 'ERROR')
    }, 3000)
  }
  
}


// WEBPACK FOOTER //
// ./src/redux/actions/paymentAccountActions.js